export type RestakingProgram = {
  version: "0.1.0"
  name: "restaking_program"
  instructions: [
    {
      name: "initializeConfig"
      accounts: [
        {
          name: "authority"
          isMut: true
          isSigner: true
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "rent"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "bump"
          type: "u8"
        },
        {
          name: "operator"
          type: "publicKey"
        },
      ]
    },
    {
      name: "initializeVault"
      accounts: [
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "vaultTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "allowedToken"
          isMut: false
          isSigner: false
        },
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "rent"
          isMut: false
          isSigner: false
        },
        {
          name: "tokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "associatedTokenProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "allowedToken"
          type: "publicKey"
        },
        {
          name: "lockupMinStakeds"
          type: {
            array: ["u64", 4]
          }
        },
        {
          name: "lockupDurations"
          type: {
            array: ["i64", 4]
          }
        },
        {
          name: "emissionPerDay"
          type: "u64"
        },
        {
          name: "bump"
          type: "u8"
        },
      ]
    },
    {
      name: "initializeAccount"
      accounts: [
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "rent"
          isMut: false
          isSigner: false
        },
      ]
      args: []
    },
    {
      name: "stake"
      accounts: [
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "userTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vaultTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "tokenMint"
          isMut: false
          isSigner: false
        },
        {
          name: "tokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "amount"
          type: "u64"
        },
      ]
    },
    {
      name: "unstakeNWithdraw"
      accounts: [
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "userTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vaultTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "tokenMint"
          isMut: true
          isSigner: false
        },
        {
          name: "tokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "amount"
          type: "u64"
        },
      ]
    },
    {
      name: "stopUnstaking"
      accounts: [
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: []
    },
    {
      name: "depositReward"
      accounts: [
        {
          name: "authority"
          isMut: true
          isSigner: true
        },
        {
          name: "rewardTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "vaultRewardTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "rewardTokenMint"
          isMut: false
          isSigner: false
        },
        {
          name: "tokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "associatedTokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "rent"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "rewardAmount"
          type: "u64"
        },
      ]
    },
    {
      name: "claimReward"
      accounts: [
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "userTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vaultTokenAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "rewardTokenMint"
          isMut: false
          isSigner: false
        },
        {
          name: "tokenProgram"
          isMut: false
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "feeAccount"
          isMut: true
          isSigner: false
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."]
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: []
    },
    {
      name: "addReward"
      accounts: [
        {
          name: "owner"
          isMut: true
          isSigner: true
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "rewardTokenMint"
          isMut: false
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
      ]
      args: []
    },
    {
      name: "accrueReward"
      accounts: [
        {
          name: "authority"
          isMut: true
          isSigner: true
        },
        {
          name: "stakingAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "vault"
          isMut: true
          isSigner: false
        },
        {
          name: "configAccount"
          isMut: true
          isSigner: false
        },
        {
          name: "systemProgram"
          isMut: false
          isSigner: false
        },
      ]
      args: [
        {
          name: "staker"
          type: "publicKey"
        },
      ]
    },
  ]
  accounts: [
    {
      name: "stakingAccount"
      type: {
        kind: "struct"
        fields: [
          {
            name: "owner"
            type: "publicKey"
          },
          {
            name: "vault"
            type: "publicKey"
          },
          {
            name: "stakedAmount"
            type: "u64"
          },
          {
            name: "unstakedAmount"
            type: "u64"
          },
          {
            name: "unlockTimestamp"
            type: "i64"
          },
          {
            name: "lastStaked"
            type: "i64"
          },
          {
            name: "rewards"
            type: {
              vec: {
                defined: "AccountReward"
              }
            }
          },
        ]
      }
    },
    {
      name: "vault"
      type: {
        kind: "struct"
        fields: [
          {
            name: "vaultOwner"
            type: "publicKey"
          },
          {
            name: "allowedToken"
            type: "publicKey"
          },
          {
            name: "allowedTokenDecimals"
            type: "u8"
          },
          {
            name: "vaultTokenAccount"
            type: "publicKey"
          },
          {
            name: "lockupOptions"
            type: {
              vec: {
                defined: "LockupOption"
              }
            }
          },
          {
            name: "rewards"
            type: {
              vec: {
                defined: "Reward"
              }
            }
          },
          {
            name: "bump"
            type: {
              array: ["u8", 1]
            }
          },
          {
            name: "lastStat"
            type: {
              defined: "VaultStat"
            }
          },
          {
            name: "currentStat"
            type: {
              defined: "VaultStat"
            }
          },
        ]
      }
    },
    {
      name: "config"
      type: {
        kind: "struct"
        fields: [
          {
            name: "bump"
            type: {
              array: ["u8", 1]
            }
          },
          {
            name: "feeAccount"
            type: "publicKey"
          },
          {
            name: "admin"
            type: "publicKey"
          },
          {
            name: "operator"
            type: "publicKey"
          },
        ]
      }
    },
  ]
  types: [
    {
      name: "AccountReward"
      type: {
        kind: "struct"
        fields: [
          {
            name: "accumulatedRewardAmount"
            type: "u64"
          },
          {
            name: "rewardRef"
            type: {
              defined: "Reward"
            }
          },
        ]
      }
    },
    {
      name: "Reward"
      type: {
        kind: "struct"
        fields: [
          {
            name: "rewardTokenMint"
            type: "publicKey"
          },
          {
            name: "rewardTokenDecimals"
            type: "u8"
          },
          {
            name: "timestamp"
            type: "i64"
          },
        ]
      }
    },
    {
      name: "LockupOption"
      type: {
        kind: "struct"
        fields: [
          {
            name: "duration"
            type: "i64"
          },
          {
            name: "minUnstakingAmount"
            type: "u64"
          },
        ]
      }
    },
    {
      name: "VaultStat"
      type: {
        kind: "struct"
        fields: [
          {
            name: "totalStakedAmount"
            type: "u64"
          },
          {
            name: "totalStakers"
            type: "u64"
          },
          {
            name: "emissionPerDay"
            type: "u64"
          },
        ]
      }
    },
    {
      name: "VaultError"
      type: {
        kind: "enum"
        variants: [
          {
            name: "Unauthorized"
          },
          {
            name: "InvalidAllowedToken"
          },
          {
            name: "InvalidLockupDuration"
          },
          {
            name: "InvalidLockupMultiplier"
          },
          {
            name: "InvalidLockupOption"
          },
          {
            name: "NotAllowedToken"
          },
          {
            name: "LockupDurationNotMet"
          },
          {
            name: "Overflow"
          },
          {
            name: "InsufficientFunds"
          },
          {
            name: "LockupOptionsLimitReached"
          },
          {
            name: "RewardNotFound"
          },
          {
            name: "WrongToken"
          },
          {
            name: "AlreadyInitialized"
          },
          {
            name: "WrongFeeAccount"
          },
          {
            name: "TooSoon"
          },
          {
            name: "RewardsLimitReached"
          },
          {
            name: "InvalidRewardIndex"
          },
          {
            name: "NoUnstakingProcessIsRunning"
          },
          {
            name: "UnstakeingIsEnded"
          },
          {
            name: "WithdrawalAmountMismatch"
          },
          {
            name: "NoStakedAmountToAccrue"
          },
        ]
      }
    },
  ]
  events: [
    {
      name: "VaultStatChangedEvent"
      fields: [
        {
          name: "excludeStaker"
          type: "publicKey"
          index: false
        },
        {
          name: "vault"
          type: "publicKey"
          index: false
        },
      ]
    },
  ]
}

export const IDL: RestakingProgram = {
  version: "0.1.0",
  name: "restaking_program",
  instructions: [
    {
      name: "initializeConfig",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "operator",
          type: "publicKey",
        },
      ],
    },
    {
      name: "initializeVault",
      accounts: [
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vaultTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "allowedToken",
          isMut: false,
          isSigner: false,
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "associatedTokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "allowedToken",
          type: "publicKey",
        },
        {
          name: "lockupMinStakeds",
          type: {
            array: ["u64", 4],
          },
        },
        {
          name: "lockupDurations",
          type: {
            array: ["i64", 4],
          },
        },
        {
          name: "emissionPerDay",
          type: "u64",
        },
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "initializeAccount",
      accounts: [
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "stake",
      accounts: [
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "userTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vaultTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "amount",
          type: "u64",
        },
      ],
    },
    {
      name: "unstakeNWithdraw",
      accounts: [
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "userTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vaultTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "amount",
          type: "u64",
        },
      ],
    },
    {
      name: "stopUnstaking",
      accounts: [
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "depositReward",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "rewardTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vaultRewardTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "associatedTokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "rewardAmount",
          type: "u64",
        },
      ],
    },
    {
      name: "claimReward",
      accounts: [
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "userTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vaultTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false,
          docs: ["It is safe because it is only used to transfer RENEC to a predefined fee account address."],
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "addReward",
      accounts: [
        {
          name: "owner",
          isMut: true,
          isSigner: true,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "accrueReward",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "stakingAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "vault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "configAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "staker",
          type: "publicKey",
        },
      ],
    },
  ],
  accounts: [
    {
      name: "stakingAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey",
          },
          {
            name: "vault",
            type: "publicKey",
          },
          {
            name: "stakedAmount",
            type: "u64",
          },
          {
            name: "unstakedAmount",
            type: "u64",
          },
          {
            name: "unlockTimestamp",
            type: "i64",
          },
          {
            name: "lastStaked",
            type: "i64",
          },
          {
            name: "rewards",
            type: {
              vec: {
                defined: "AccountReward",
              },
            },
          },
        ],
      },
    },
    {
      name: "vault",
      type: {
        kind: "struct",
        fields: [
          {
            name: "vaultOwner",
            type: "publicKey",
          },
          {
            name: "allowedToken",
            type: "publicKey",
          },
          {
            name: "allowedTokenDecimals",
            type: "u8",
          },
          {
            name: "vaultTokenAccount",
            type: "publicKey",
          },
          {
            name: "lockupOptions",
            type: {
              vec: {
                defined: "LockupOption",
              },
            },
          },
          {
            name: "rewards",
            type: {
              vec: {
                defined: "Reward",
              },
            },
          },
          {
            name: "bump",
            type: {
              array: ["u8", 1],
            },
          },
          {
            name: "lastStat",
            type: {
              defined: "VaultStat",
            },
          },
          {
            name: "currentStat",
            type: {
              defined: "VaultStat",
            },
          },
        ],
      },
    },
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: {
              array: ["u8", 1],
            },
          },
          {
            name: "feeAccount",
            type: "publicKey",
          },
          {
            name: "admin",
            type: "publicKey",
          },
          {
            name: "operator",
            type: "publicKey",
          },
        ],
      },
    },
  ],
  types: [
    {
      name: "AccountReward",
      type: {
        kind: "struct",
        fields: [
          {
            name: "accumulatedRewardAmount",
            type: "u64",
          },
          {
            name: "rewardRef",
            type: {
              defined: "Reward",
            },
          },
        ],
      },
    },
    {
      name: "Reward",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rewardTokenMint",
            type: "publicKey",
          },
          {
            name: "rewardTokenDecimals",
            type: "u8",
          },
          {
            name: "timestamp",
            type: "i64",
          },
        ],
      },
    },
    {
      name: "LockupOption",
      type: {
        kind: "struct",
        fields: [
          {
            name: "duration",
            type: "i64",
          },
          {
            name: "minUnstakingAmount",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "VaultStat",
      type: {
        kind: "struct",
        fields: [
          {
            name: "totalStakedAmount",
            type: "u64",
          },
          {
            name: "totalStakers",
            type: "u64",
          },
          {
            name: "emissionPerDay",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "VaultError",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unauthorized",
          },
          {
            name: "InvalidAllowedToken",
          },
          {
            name: "InvalidLockupDuration",
          },
          {
            name: "InvalidLockupMultiplier",
          },
          {
            name: "InvalidLockupOption",
          },
          {
            name: "NotAllowedToken",
          },
          {
            name: "LockupDurationNotMet",
          },
          {
            name: "Overflow",
          },
          {
            name: "InsufficientFunds",
          },
          {
            name: "LockupOptionsLimitReached",
          },
          {
            name: "RewardNotFound",
          },
          {
            name: "WrongToken",
          },
          {
            name: "AlreadyInitialized",
          },
          {
            name: "WrongFeeAccount",
          },
          {
            name: "TooSoon",
          },
          {
            name: "RewardsLimitReached",
          },
          {
            name: "InvalidRewardIndex",
          },
          {
            name: "NoUnstakingProcessIsRunning",
          },
          {
            name: "UnstakeingIsEnded",
          },
          {
            name: "WithdrawalAmountMismatch",
          },
          {
            name: "NoStakedAmountToAccrue",
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "VaultStatChangedEvent",
      fields: [
        {
          name: "excludeStaker",
          type: "publicKey",
          index: false,
        },
        {
          name: "vault",
          type: "publicKey",
          index: false,
        },
      ],
    },
  ],
}
